<template>
  <PSelect
    v-model="selectedCountry"
    :disabled="disabled"
    :items="countries"
    :label="label"
    :required="required"
    itemText="text"
    itemValue="value"
  />
</template>

<script>
import { defineComponent, onMounted, ref, watch } from "vue";
import api from "../api"

export default defineComponent({
  name: "CountrySelect",
  props: {
    value: { type: String },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
    required: { type: Boolean, default: false }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const selectedCountry = ref(props.value)
    const countries = ref([])

    watch(selectedCountry, () => {
      emit('input', selectedCountry.value)
    })

    watch(() => props.value, (newValue) => {
      if (newValue !== selectedCountry.value) selectedCountry.value = newValue
    })

    onMounted(async () => {
      const allCountries = await api.countriesGet()
      countries.value = allCountries.map(element => {
        return {
          value: element.id,
          text: element.name
        }
      })
      if (props.value) return
      selectedCountry.value = countries.value.length ? countries.value[0]?.value : ''
    })

    return {
      selectedCountry,
      countries
    }
  },
})
</script>
